// ja.ts — 일본어 문구
export const ja = {
      _l: "ja",
      eyebrow: "MolePin エアドロップ · 無料MOL",
      h1: '取引所でBNBを受け取った方へ<br><span class="g">MOL 1万枚を無料で。</span>',
      lede: "取引所からの入金<em>1件につき10,000 MOL</em>（最大10件）。<em>Xフォロー 10,000 MOL</em> + <em>テレグラム 10,000 MOL</em> — 入金がなくても<em>20,000 MOL</em>。ウォレットあたり最大<em>120,000 MOL</em>。",
      notConnected: "鉱脈に紐づくウォレットなし",
      exchLabel: "鉱脈連携取引所:",
      fcfsLabel: "入場したデナー",
      railTitle: "鉱脈の印",
      sealDepName: "入金", sealDepDesc: "取引所があなたのウォレットにBNB(またはBNBチェーンのトークン)を送金。入金1件につき10,000 MOL、最大10件。",
      sealDepBtn: "入金を証明",
      proveMore: function (n: number) { return "追加登録 (" + n + "/10)"; },
      proveFull: "10件すべて請求済み",
      sealXName: "𝕏フォロー", sealXDesc: "𝕏でMolePinをフォロー → 10,000 MOL。一度だけ。",
      sealXBtn: "𝕏を連携",
      sealTgName: "テレグラム", sealTgDesc: 'グループに「MolePin Up」と投稿 → 10,000 MOL。一度だけ。',
      sealTgBtn: "巣穴を開く",
      stLocked: "未封印", stDone: "封印済",
      digTitleLocked: "土の山は閉じている", digSubLocked: "三つの印を全て集めれば大地が割れ、MOLを掘れる。",
      digBtnLocked: "印が未完成",
      digTitleOpen: "鉱脈が開く", digSubOpen: "三つの印が金色に燃える。大地を打ち、契約が負う分を受け取れ。",
      digBtnOpen: "MOLを掘る",
      modalTitle: "入金の証明",
      eligibleNote: "⚠️ 取引所（Binance、Coinbaseなど）からご自身のウォレットへ直接受け取った<b>0.001 BNB以上</b>の入金のみ対象です。個人ウォレット・DEX・他人からの送金は対象外です。",
      modeScan: "自動スキャン", modeTx: "txid入力",
      scanHint: function (ex: string) { return "ウォレットから" + ex + "発のBNB入金を検索します。"; },
      scanBtn: "入金を検索",
      txHint: "BNB入金のtxハッシュを改行区切りで最大10件貼り付け。",
      txGuideTitle: "📖 TXハッシュの探し方",
      txGuideHint: "BscScanでウォレットの取引履歴を開き、Fromが取引所（Binanceなど）で緑のINバッジがある行を見つけ、Transaction Hashをコピーします。",
      tryTxidTitle: "自動で見つかりませんか？",
      tryTxidBody: "ご利用の取引所ホットウォレットがまだリストにない場合があります。入金のTXハッシュを直接貼り付けできます — BscScanで取引所入金（緑のIN）を見つけてハッシュをコピー。",
      tryTxidBtn: "TXハッシュを手動入力",
      verifyTxBtn: "txidを検証",
      claimBtn: "MOLを掘る",
      loreTitle: "鉱脈",
      loreBody: "<strong>エルドラシア</strong>、17の黄金モグラ部族の地下王国。十六が消えた後、最後の後継者<strong>モルピン</strong>が再び掘る。<strong>デナー</strong>は鉱脈の守護者として傍らに立つ。印は、鉱脈があなたを本物と知る術だ。",
      trust: "取引所とは無関係のモルピン・コミュニティ企画です。対象判定は公開オンチェーンデータのみに基づきます。署名はウォレット所有権の証明で、送金や承認は要求しません。投資助言ではありません。",
      dexMsg: "<b>ウォレットに名前</b>を — 0xの代わりに読みやすい名前を。DEXignation公開中。",
      dexCta: "名前を作成",
      linksTitle: "鉱脈の門 & 同盟",
      linksSub: "BNBを移す取引所を開くか、同盟サイトを訪れてください。",
      linksExch: "取引所",
      linksPartner: "提携サイト",
      linksCommunity: "コミュニティ",
      linksChannelTag: "チャンネル · お知らせ",
      linksGroupTag: "グループ · 印を獲得",
      linksDigmolTag: "デナー / 分配者",
      linksDexTag: "提携",
      inappMsg: "このアプリ内ブラウザではウォレットが動作しません。外部ブラウザで開いてください。",
      inappBtn: "ブラウザで開く",
      inappManual: "右上の ⋯ メニュー →「外部ブラウザで開く」をタップしてください。",
      sealCount: function (n: number) { return n + " / 3"; },
      validCount: function (n: number) { return "入金 " + n + "件を検証"; },
      depositsFound: function (n: number, bnb?: string) { return "入金 " + n + "件" + (bnb ? " (" + bnb + " BNB)" : "") + " 確認 ✓"; },
      willGetMol: function (m: string) { return "→ " + m + " MOL を受け取ります"; },
      noDepositsBig: "BNB入金 0件",
      alreadyClaimed: "請求済み",
      alreadyClaimedBig: "請求済みの入金",
      alreadyClaimedNote: "この入金はすでに請求に使用されています",
      myTxTitle: "登録済みの入金",
      myTxConfirmed: "請求済み",
      myTxPending: "処理中",
      noValid: "対象の取引所入金が見つかりません",
      claimAmt: function (m: string) { return m + " MOLを掘る"; },
      noGas: "claimにはガス代のBNBが少し必要です。BNBを補充してから再度お試しください。",
      errTxidUsed: "この入金はすでに請求済みです。",
      errBadSigner: "署名エラーです。更新してもう一度お試しください。",
      errExpired: "リクエストの有効期限が切れました。もう一度お試しください。",
      errWalletCap: "このウォレットは請求上限（10件）に達しました。",
      errClaimerLimit: "エアドロップは終了しました（先着10,000名）。",
      errPaused: "請求は一時停止中です。",
      errNothing: "請求できる内容がありません。",
      errTransferFail: "トークン送信に失敗しました。後でもう一度お試しください。",
      dug: function (m: string) { return "金脈を掘り当てた — " + m + " MOL獲得。"; },
      needConnect: "先に鉱脈へウォレットを紐づけてください。",
      overLimit: "txidは最大10件。",
      fcfsClosed: "満員", fcfsRemaining: function (r: number) { return "残り " + r + "席"; }, fcfsMax: "試練満員",
      errClosed: "10,000のデナー席が全て埋まりました。",
      errCap: "このウォレットは既に10件掘りました。",
      xBound: function (h: string) { return "𝕏連携済: @" + h; },
      tgHelp: "1. グループに参加  2. 「MolePin Up」または「MolePin 화이팅」と投稿  3. 完了。",
      openTg: "テレグラムを開く", copyPhrase: "「MolePin Up」をコピー", phraseCopied: "コピー済!",
      errNoMM: "MetaMaskが必要です。", errNoCB: "Coinbase Walletが必要です。", cancelled: "キャンセルされました。",
      connTimeout: "MetaMask から応答がありません。もう一度接続してください。",
      connecting: "MetaMask に接続中… アプリで承認して戻ってください。",
      cancel: "キャンセル",
      copyAddr: "クリックで全アドレスをコピー", copied: "✓ コピー済!",
      disconnect: "接続解除",
      donateTitle: "寄付",
      donateNote: "イーサリアム · BNBチェーン · ポリゴン",
      donateWarn: "上記のネットワークのみご利用ください。他のネットワークでは資産を失う可能性があります。",
      donateCopied: "アドレスをコピーしました",
      wrongChainWarn: "ネットワークが違います。BNB スマートチェーンに切り替えてください。",
      switchChainBtn: "ネットワーク切替",
      wrongChainAlert: "BNB スマートチェーンに切り替えてください。",
      wrongChainRejected: "ネットワークを切り替えないと MOL を掘れません。",
      bonusClaim: "10,000 MOL を受け取る",
      bonusClaiming: "署名をリクエスト中…",
      bonusPending: "処理中…",
      bonusReceived: "✓ 受取済み",
      bonusDone: "10,000 MOL を受け取りました！",
      bonusAlready: "すでに受け取り済みです。",
      bonusNeedSeal: "先に印章を獲得してください。",
      bonusCapReached: "請求上限に達しています。",
      xErrDup: "この 𝕏 アカウントは既に別のウォレットで印章を取得済みです。X アカウント1つにつきウォレット1つです。",
      xErrFollow: "フォローを確認できませんでした。𝕏 で MolePin をフォローしてから再試行してください。",
      xErrGeneric: "𝕏 認証に失敗しました。しばらくしてからお試しください。",
      rsnBelowMin: "0.001 BNB 以上である必要があります",
      rsnNotExchange: "取引所からの入金ではありません",
      rsnRecipient: "接続中のウォレット宛の入金ではありません",
      rsnNotFound: "トランザクションが見つかりません",
      rsnNotConfirmed: "まだ確定していないトランザクションです",
      rsnUnknown: "対象外の入金です",
};
export default ja;